import { ResolveFn, Router } from '@angular/router';
import { InstitutionService } from '../services/institution.service';
import { catchError, of } from 'rxjs';
import { Institution } from '../models/institution';
import { inject } from '@angular/core';

export const institutionResolver: ResolveFn<Institution | null> = () => {
  const institutionService: InstitutionService = inject(InstitutionService);
  const router: Router = inject(Router);

  return institutionService
    .getCurrentInstitution()
    .pipe(
      catchError(() => {
        router.navigate(['/institution-select']);

        return of(null);
      })
    );
};
